import React, { useState } from "react"; 
import { PiInfinityBold } from "react-icons/pi";
import { QuantityType } from "../../types/ProductType";
import { TfiArchive } from "react-icons/tfi";
import { useTranslation } from "react-i18next";

interface QuantityInputProps {
  quantity: QuantityType | string;
  onChange: (quantity: QuantityType) => void;
  place?: "card" | "modal";
}

const QuantityInput: React.FC<QuantityInputProps> = ({
  quantity,
  onChange,
  place = "card",
}) => {
  // const min = 0;
  // const max = 999999;
  const { t } = useTranslation();


  const [isHoverd, setIsHovered] = useState(false);
  // Handle input change
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
  
    // Allow empty input to show the placeholder
    if (value === "") {
      // Disable esLint Because we need that Behavior of make a placeholder
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      onChange("");
      return;
    }
  
    // Ensure the value is numeric
    if (!isNaN(Number(value)) && /^\d*$/.test(value)) {
      let newValue = value;
  
      // Remove leading zeros except when the value is "0"
      if (value.length > 1 && value.startsWith("0")) {
        newValue = value.replace(/^0+/, '');
        // If all zeros were removed and the value is empty, set it to "0"
        if (newValue === "") {
          newValue = "0";
        }
      }
  
      // Disable esLint Because we need that Behavior of make a placeholder
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      onChange(newValue);
    }
  };



  return (
    <div className={`flex w-full items-center border overflow-hidden border-gray-200 ${place === "card" ? "rounded-md" :"rounded-sm"}`}>
      {/* Number Input Field */}
      <div className={`flex h-12 ${place === "card" ? "md:h-9" :"md:h-12"} w-full items-center relative`}>
        <TfiArchive
          size={18}
          className="absolute start-2 top-1/2 -translate-y-1/2 text-gray-400"
        />
        <input
          type="text"
          name="quantity"
          id="quantity"
          disabled={quantity === "infinite"}
          value={quantity === "infinite" ? t("quantityInput.unlimited") as string : quantity}
          onChange={handleInputChange}
          className={`h-full w-full pt-1 border-none ps-10 outline-none ${
            quantity === "infinite"
              ? "placeholder:text-gray-800"
              : "placeholder:text-gray-400"
          }`}
          // min={min}
          // max={max}
          placeholder={ t("quantityInput.label")  as string}
        />
        {isHoverd && <span className={`absolute bg-skyblue text-sidebar px-2 py-[2px] top-1/2 end-[10px] -translate-y-1/2 text-sm font-semibold rounded-sm hidden md:block`}>
        {t("quantityInput.unlimited")}
        {/* tooltip arrow */}
        <span className="absolute top-1/2 end-[-4px]  -translate-y-1/2 rotate-45 w-2 h-2 bg-skyblue"></span>
        </span>}
      </div>

      {/* Infinity Button */}
      <button
        type="button"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={() => {
          if (quantity === "infinite") {
            onChange(1);
          } else {
            onChange("infinite");
          }
        }}
        className={`flex items-center justify-center rounded-sm  border-gray-200 border-s p-4 ${place === "card" ? "md:p-2" : "md:p-4"} text-gray-700 ${
          quantity === "infinite" ? "text-green-800" : ""
        }`}
      >
        <PiInfinityBold />
        
      </button>
    </div>
  );
};

export default QuantityInput;
